'use client';

import { ChatContact } from '../../types/chat';

interface ContactItemProps {
  contact: ChatContact;
  onClick: () => void;
}

export function ContactItem({ contact, onClick }: ContactItemProps) {
  const formatTime = (timestamp?: Date) => {
    if (!timestamp) return '';

    const now = new Date();
    const diff = now.getTime() - timestamp.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return '방금 전';
    if (minutes < 60) return `${minutes}분 전`;
    if (hours < 24) return `${hours}시간 전`;
    if (days < 7) return `${days}일 전`;

    return timestamp.toLocaleDateString('ko-KR', {
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <button
      onClick={onClick}
      className="w-full p-4 hover:bg-[#F5F7F9] transition-colors duration-200 border-b border-[#DEE2E7] text-left"
    >
      <div className="flex items-center space-x-3">

        {/* Contact info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h3 className="font-medium text-[#323B49] truncate">
              {contact.name}
            </h3>
            <span className="text-xs text-[#ACB3BE] flex-shrink-0">
              {formatTime(contact.lastMessageTime)}
            </span>
          </div>

          <div className="flex items-center justify-between">
            <p className="text-sm text-[#6D717D] truncate">
              {contact.lastMessage || '메시지가 없습니다'}
            </p>

            {/* Unread count badge */}
            {contact.unreadCount > 0 && (
              <div className="bg-[#EF4444] text-white text-xs rounded-full min-w-[20px] h-5 flex items-center justify-center px-1 flex-shrink-0 ml-2">
                {contact.unreadCount > 99 ? '99+' : contact.unreadCount}
              </div>
            )}
          </div>
        </div>
      </div>
    </button>
  );
}